module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/suns_styled_02-3a60f745f7db5da7539abc1145329b60.png";